import React from 'react'
import './About.css'
import './Animation.css'



export default function About() {
  return (
    <>
   
      
    <div className=' bg container-fluid  text-light py-5 '>
      <h1 className='my-3  text-center display-5 fw-bold shadow text-shadow vxeq' style={{fontWeight:"1500",letterSpacing:"2px"}}>ABOUT US</h1>
      <div className="py-5 px-4">
        <p className='fs-5 fw-bold text-center shadow'  style={{letterSpacing:"2px",wordSpacing:"1px"}}>VXEQ.IFPL offer to nail down existing facilities management service providers
              to cut the cost by 25% and to improve the quality by 100%.</p>
            <h2 className='text-center fw-bold my-4 my-5 fs-3 'style={{letterSpacing:"4px"}}>HOMEATZ GLOBAL</h2>
            <p className='fs-5 text-center fw-bold'  style={{letterSpacing:"2px",wordSpacing:"1px"}}>Work From Home-Earn from Home Worldwide Global Opportunity via app on Apple and Google Play Store</p>

            <h4 className='text-center fw-bold mt-5 mb-5 fs-1 pt-5 ' style={{letterSpacing:"4px"}}>Salient Features</h4>
           <div className='mb-5 mt-4' style={{letterSpacing:"2px"}}>
            <p className='fs-6 fw-bold'>1- You can put pressure on existing fms provider to reduce rate by
              25%, by giving them offer as attached, of alternative agency and a
              threat that if not yielded you may move the matter to consumer forum
              (NCDRC) for
              direct indirect losses to consumers, due to excess CAM & poor QUAL ITY.</p>
            <p className='fs-6  fw-bold'>2- VXEQ offers to undertake that it is willing to replace the existing service provider CAM with 25% cut and assurance that all the cost components shall be shared online with all
              stack holders by digitally instant software and decision making shall
              be by eVoting to improve the services.</p>
            <p className='fs-6 fw-bold mb-5'>3- VXEQ offers to outsource the fms contract to respective AOA,
              with the condition that a separate current bank account will be opened
              for respective aoa, after signing an mom that for profit loss
              respective AOA shall be responsible, accounting shall have to be
              transparent via VXEQ app, but if AOA earns any profit, than only
              10% of profit earned shall be VXEQ share and in return VXEQ shall
              provide FREE Technical Audit Of Building and Guidance /assistance
              in taking/ handing over of inventories/ records from builder,
              beside providing a free software
              for digital transparency and instant accounting, eVoting software.</p>
              </div>
              </div>
              </div>
              
    </>
  )
}
